var render, staticRenderFns
import script from "./on_product.vue?vue&type=script&lang=js"
export * from "./on_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1155b5e4')) {
      api.createRecord('1155b5e4', component.options)
    } else {
      api.reload('1155b5e4', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms/views/on_product/on_product.vue"
export default component.exports